// extracted by mini-css-extract-plugin
module.exports = {"baseList":"BaseList_baseList_ViA2A"};